<!-- <app-page -->
<!--   title="Подпись документов" -->
<!--   [backBtn]="true" -->
<!--   *ngIf="loader$ | async" -->
<!-- > -->
<!--  <app-page-header title="Подпись документов" [backBtn]="true"></app-page-header>-->
<app-page-wrapper
  [useHeader]="true"
  [useBackBtn]="true"
  [useFooter]="true"
  [title]="title"
  [subtitle]="subtitle"

>
  <ion-content>
    <div class="step-online-credit" *ngIf="loader$ | async">
      <div class="online-credit-documents" *ngIf="creditDocuments" [formGroup]="documentsForm">
        <div class="online-credit-documents__label">Для выдачи кредита необходимо подписать документы</div>
        <app-form-checkbox *ngFor="let doc of creditDocuments"
                             [formControlName]="doc.id"
                             [option]="getDocName(doc.fileName)"
                             [base64Data]="doc?.fileDate"
                             [base64FileName]="doc?.fileName"
                             [base64FileType]="doc?.fileType"
        ></app-form-checkbox>
      </div>
      <app-loader rounded *ngIf="signDock"></app-loader>
    </div>
  </ion-content>

  <ng-container footer *ngIf="loader$ | async">
    <ion-button expand="block" class="button block primary" ripple-effect
                [disabled]="documentsForm.invalid" (click)="confirmCredit()">Подтвердить</ion-button>
  </ng-container>

</app-page-wrapper>



<!-- </app-page> -->
